import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// import data from '../data.json'
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
// import axios from 'axios';
import { Link } from "react-router-dom";
import "../App.css";
import axiosIns from "../components/axiosIns";
import { faCalendarAlt, faEdit, faEye, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const styles = [
  `
  .bt_view{ height: 2opx !important; margin-left: 20px; width: 20px !important; font-size: 14px; height: 30px; }
  .rdt_TableRow{ padding: 1%; }
  .marquee {
    font-size: 24px;
    color: #06603a;
    margin-bottom : 10px;
  }
`,
];
const addDropDown = (param) => {
  console.log(param);

  return (
    <>
      <div>
        <Link to={`/employee_profile/${param._id}`}>
        <FontAwesomeIcon icon={faEye} className="bt_view" style={{color:'blue'}}/>
        </Link>
      </div>
    </>
  );
};

const getProfile = (param) => {
  return (
    <>
      <img
        height={50}
        width={50}
        style={{ borderRadius: "10%", width: "85px", height: "100px" }}
        src={param.picture ? param.picture : "./images/noimg.jpg"}
      />
    </>
  );
};

const columns = [
  {
    name: "Name & Company",
    cell: (row) => (
      <div>
        {row.name} <br />
        <br /> ({row.company_name})
      </div>
    ),
    sortable: true,
  },
  {
    name: "Picture",
    selector: (param) => getProfile(param),
    sortable: true,
  },
  {
    name: "Mobile",
    selector: "mobile",
    sortable: "true",
  },
  {
    name: "Age",
    selector: "age",
    sortable: "true",
  },
  {
    name: "Emp ID",
    selector: "employee_id",
    sortable: "true",
  },
  // {
  //   name : 'Service',
  //   selector: 'service',
  //   sortable:'true'
  // },
  // {
  //   name : 'Date',
  //   selector : 'date',
  //   sortable : true
  // },
  {
    name: "Actions",
    // selector :'actions',
    selector: (param) => addDropDown(param),
  },
];

function Employee() {
  const [data, setData] = useState([]);
  // const userToken = localStorage.getItem('token');
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    // axios.defaults.headers.common['Authorization'] = userToken
    await axiosIns
      .post("/employee_list")
      .then((res) => {
        setData(res.data.data);
        setFilteredData(res.data.data);
        setLoading(false);
        console.log(data);
      })
      .catch((err) => {
        if (err.response.data.msg == "token") {
          localStorage.clear("isLogin");
          window.location.reload("/");
        }
        console.log(err.response);
      });
  };

  useEffect(() => {
    const checkTokenExpiration = setInterval(() => {
      const expirationTime = localStorage.getItem("tokenExpirationTime");
      if (expirationTime && Date.now() > parseInt(expirationTime)) {
        localStorage.clear("isLogin");
        window.location.reload("/");
      }
    }, 1000);

    clearInterval(checkTokenExpiration);
    getData();
  }, []);

  const [filteredData, setFilteredData] = useState(data);

    const filterData = (value) => {
      const lowerCaseValue = value.toLowerCase().trim();
      const filteredData = data.filter((item) =>
        item.name.toLowerCase().includes(lowerCaseValue)
      );
      setFilteredData(filteredData);
    };

    const [searchValue, setSearchValue] = useState("");

    const handleSearch = (event) => {
      setSearchValue(event.target.value);
      filterData(event.target.value);
    };

  return (
    <>
      <style>{styles}</style>
      <div className="App" style={{ width: "100%" }}>
        <div align='left'>
        <input style={{width :"30%",borderRadius:"50px",marginRight:"770px",padding:"20px"}}
            type="text"
            placeholder="Search Employee by Name"
            value={searchValue}
            onChange={handleSearch}/>
        </div>
        {loading ? (
          <table className="loader">
            <tbody>
              <tr>
                <td></td>
              </tr>
            </tbody>
          </table>
        ) : (
          <DataTable
            title="Employee List"
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
          />
        )}
      </div>
    </>
  );
}

export default Employee;
